import React from 'react';

const SeparatorLine = () => {
  return (
    <hr style={{
      width: '100%',
      border: 'none',
      borderTop: '1px solid black',
      margin: '1rem 0'
    }} />
  );
};

export default SeparatorLine;